import Layout from "@/views/layout";

const clerkRouter = {
  path: "/clerk",
  name: "Clerk",
  component: Layout,
  meta: { title: "店员模块" },
  children: [
    {
      path: "salesclerkList",
      name: "SalesclerkList",
      component: () => import("@/views/clerk/salesclerkList"),
      meta: { title: "店员列表" }
    },
    {
      path: "salesclerkAdd",
      name: "SalesclerkAdd",
      component: () => import("@/views/clerk/salesclerkAdd"),
      meta: { title: "新增店员" }
    }
  ]
};

export default clerkRouter;
